module.exports = __webpack_public_path__ + "img/indiastable_tech_Normal_ua.ab8de98e.webp";